export default "__VITE_ASSET__BdxyGhg$__"